// store.jsx — estado derivado del contexto padre (sin eventBus)
import { createContext } from "preact";
import { useContext, useMemo } from "preact/hooks";
import { useProjectDetailPage } from "../store"; // 👈 MISMO módulo padre

export const CardClientContext = createContext(null);

export function useCardClient() {
  const ctx = useContext(CardClientContext);
  if (!ctx) throw new Error("useCardClient must be used within CardClientProvider");
  return ctx;
}

export function CardClientProvider({ children }) {
  const { project, role } = useProjectDetailPage();

  const client = useMemo(
    () => (project?.client ? project.client : null),
    [project]
  );

  const value = useMemo(
    () => ({
      project,
      role,
      client,
      isReady: !!client,
    }),
    [project, role, client]
  );

  return (
    <CardClientContext.Provider value={value}>
      {children}
    </CardClientContext.Provider>
  );
}
